import * as React from 'react'

import { Box, Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Files } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import CopyPeriodWizard from 'modules/shift_management/components/ShiftManagement/CopyPeriodWizard'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'

interface Props {
  disabled?: boolean
}
const CopyPeriodButton = ({ disabled }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false)
  const [isTooltipOpen, toggleTooltip] = useToggle(false)
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')
  return (
    <>
      {isModalOpen && <CopyPeriodWizard onClose={() => setIsModalOpen(false)} />}
      <Box onMouseEnter={toggleTooltip(!disabled)} onMouseLeave={toggleTooltip(false)}>
        <Tooltip.Alt
          open={isTooltipOpen}
          attachment="top center"
          label={i18n.t('shift_management.actions.copy_schedule_period')}
        >
          {newEntryFlowEnabled ? (
            <F0Button
              hideLabel
              icon={Files}
              onClick={() => setIsModalOpen(true)}
              size="md"
              variant="outline"
              disabled={disabled}
            />
          ) : (
            <Button
              type="secondary"
              onClick={() => setIsModalOpen(true)}
              disabled={disabled}
              iconName="layers-front"
            />
          )}
        </Tooltip.Alt>
      </Box>
    </>
  )
}

export default CopyPeriodButton
